import React from 'react';

import { shallowEqual, useSelector } from 'react-redux';

import ReportActions from '../../../report-actions';
import { EXPORT_CSV, EXPORT_EXCEL, EXPORT_PDF } from '../../../report-actions/constants';
import ReportFilters from '../../../report-filters';
import { DATE_RANGE_PROPS, STORE_PROPS, SHOW_PRODUCT_SALES_BY_OPTIONS } from '../../../report-filters/report-paramter-input-properties';
import { buildDropdownOptions } from '../../../report-filters/filters/dropdown/helpers';

const actions = [EXPORT_PDF, EXPORT_EXCEL, EXPORT_CSV];

const filtersProps = [DATE_RANGE_PROPS, STORE_PROPS, SHOW_PRODUCT_SALES_BY_OPTIONS];

const ProductSales = () => {
  const updatedFiltersProps = useSelector((state) => buildDropdownOptions({ filtersProps, state }), shallowEqual);

  return (
    <>
      <ReportFilters filtersProps={updatedFiltersProps} />
      <ReportActions actions={actions} />
    </>
  );
};

export default ProductSales;
